import { Nullable } from 'utils/types';
import { Club, Network } from '../../api/types';
import { ADDRESS_NAMES } from '../Form/Address/types';
import { Firm } from 'screens/BrokerPortal/screens/Registration/api';
import { Step } from 'screens/BrokerPortal/screens/Registration/steps';
import { State } from 'screens/BrokerPortal/screens/Registration/store/types';

export enum FIELD_LABELS {
  FIRM_NAME = 'Firm name',
  FCA_NUMBER = 'FCA number',
  SEARCH_FIRM_ADDRESS = 'Search by postcode',
  FIRM_EMAIL = 'Firm email address',
  FIRM_PHONE = 'Firm phone number',
}

export enum FIELD_NAMES {
  FIRM_NAME = 'firmName',
  FCA_NUMBER = 'fcaNumber',
  SEARCH_FIRM_ADDRESS = 'searchFirmAddress',
  FIRM_EMAIL = 'firmEmail',
  FIRM_PHONE = 'firmPhone',
  FIRM_TYPE = 'firmType',
  HAS_PERMISSION_TO_REGISTER_FIRM = 'hasPermissionToRegisterFirm',
  FIRM_ADDRESS = 'firmAddress',
  CLUB = 'club',
  NETWORK = 'network',
}

export enum FIRM_TYPE {
  DA = 'DA',
  AR = 'AR',
}

export type Form = {
  [FIELD_NAMES.FIRM_NAME]: Nullable<string>;
  [FIELD_NAMES.FCA_NUMBER]: Nullable<string>;
  [FIELD_NAMES.SEARCH_FIRM_ADDRESS]: Nullable<string>;
  [FIELD_NAMES.FIRM_EMAIL]: Nullable<string>;
  [FIELD_NAMES.FIRM_PHONE]: Nullable<string>;
  [FIELD_NAMES.FIRM_TYPE]: Nullable<string>;
  [FIELD_NAMES.HAS_PERMISSION_TO_REGISTER_FIRM]: Nullable<boolean>;
  [FIELD_NAMES.NETWORK]: Nullable<string>;
  [FIELD_NAMES.CLUB]: Nullable<string>;
  [ADDRESS_NAMES.ADDRESS_LINE_1]: Nullable<string>;
  [ADDRESS_NAMES.ADDRESS_LINE_2]: Nullable<string>;
  [ADDRESS_NAMES.ADDRESS_LINE_3]: Nullable<string>;
  [ADDRESS_NAMES.CITY]: Nullable<string>;
  [ADDRESS_NAMES.COUNTY]: Nullable<string>;
  [ADDRESS_NAMES.POSTCODE]: Nullable<string>;
};

export type Props = {
  form: Form;
  searchFirmForm: State['searchFirms']['form'];
  clubs: { loading: boolean; items: Club[] };
  networks: { loading: boolean; items: Network[] };
  setRegisterFirmForm: (data: Form) => void;
  loadClubsByClubName: (clubName: string) => any;
  loadNetworksByNetworkName: (networkName: string) => any;
  setContextFirm: (firm: Nullable<Firm>) => void;
  setCurrentStep: (step: Step) => void;
};
